import type { FC } from "react";

import { TerminalBatchUpdateForm } from "src/app/features/Terminal/components/forms/TerminalBatchUpdateForm";
import { useTerminalBatchUpdateMutation } from "src/app/features/Terminal/services/server/TerminalApi";
import type { TerminalBatchUpdateEntity } from "src/app/features/Terminal/types/TerminalBatchUpdateEntity";
import type { TerminalList } from "src/app/features/Terminal/types/TerminalList";
import { TerminalType } from "src/app/features/TerminalProfile/types/TerminalProfileType";
import { BatchUpdateDrawerButton } from "../../../../../components/DrawerForm/BatchUpdateDrawer/BatchUpdateDrawerButton";
import { useBatchUpdateDrawer } from "../../../../../components/DrawerForm/BatchUpdateDrawer/useBatchUpdateDrawer";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";

export const TerminalBatchUpdateButton: FC<ButtonProps<TerminalList>> = ({ isDisabled, items }) => {
    const hasOptTerminal = items?.some((item) => item.terminalType === TerminalType.ISOPT) ?? false;

    const [saveFormData] = useTerminalBatchUpdateMutation();
    const { open, form, isDisabledFinal, isSubmitting, showDrawer, onClose, onSubmit } = useBatchUpdateDrawer<
        TerminalBatchUpdateEntity,
        TerminalList
    >(items, isDisabled, saveFormData);

    return (
        <BatchUpdateDrawerButton
            isDisabled={isDisabledFinal}
            open={open}
            onOpen={showDrawer}
            onClose={onClose}
            isSubmitting={isSubmitting}
            titleKey="terminal.batchUpdate.header"
        >
            <TerminalBatchUpdateForm form={form} searchCallback={onSubmit} showOptTerminalProfileField={hasOptTerminal} />
        </BatchUpdateDrawerButton>
    );
};
